import {XauditModel} from '../xaudit.model';
import {OrganizationDataModel} from '../organization/organization-data.model';

export class ClientLocationDataModel extends XauditModel {
  LOCID: number;
  TDOCID: number;
  Name: string;
  OrganizationID: string;
  WorkRegionID: string;
  cfgTDOClient: string;
  NPI: string;
  FormsRepoCaseProcedureId: string;
  SMSSendFromAddress: string;
  TDO12_LOCID: string;
  LocationShortName: string;
  EmailReturnAddress: string;
  TZID: string;

  dataOrganizations: OrganizationDataModel[];

  CanceledApptOperatoryId: string;
  isPrimary: boolean;
}
